import React from "react";
import { Route, Redirect } from "react-router-dom";
import { authUser, authAdmin } from "../Functions/functions";

export const ProtectedRoute = ({ component: Component, ...rest }) => {
  console.log(
    authUser(localStorage.getItem("JWT")),
    authAdmin(localStorage.getItem("JWT"))
  );
  return (
    <Route
      {...rest}
      render={(props) => {
        if (
          authUser(localStorage.getItem("JWT")) &&
          !authAdmin(localStorage.getItem("JWT"))
        ) {
          return <Component {...props} />;
        } else {
          if (
            authUser(localStorage.getItem("JWT")) &&
            authAdmin(localStorage.getItem("JWT"))
          ) {
            return (
              <Redirect
                to={{
                  pathname: `/admin`,
                  search: `${props.location.search}`,
                  state: {
                    from: props.location,
                  },
                }}
              />
            );
          }
          return (
            <Redirect
              to={{
                pathname: `/signin`,
                search: `${props.location.search}`,
                state: {
                  from: props.location,
                },
              }}
            />
          );
        }
      }}
    />
  );
};

export const AdminRoute = ({ component: Component, ...rest }) => {
  return (
    <Route
      {...rest}
      render={(props) => {
        if (authAdmin(localStorage.getItem("JWT"))) {
          return <Component {...props} />;
        } else {
          return (
            <Redirect
              to={{
                pathname: `/signin`,
                search: `${props.location.search}`,
                state: {
                  from: props.location,
                },
              }}
            />
          );
        }
      }}
    />
  );
};
